export { default as DiscountBadgeUrgent } from './DiscountBadgeUrgent';
